import { type Community } from "@entities";

/** IDs that cannot be selected as parent (self + all descendants). */
export function getInvalidParentCommunityIds(
  communityId: string | undefined,
  communities: Community[],
): Set<string> {
  if (!communityId) return new Set();

  const invalid = new Set<string>([communityId]);
  let frontier = [communityId];

  while (frontier.length > 0) {
    const next: string[] = [];
    for (const parentId of frontier) {
      for (const community of communities) {
        if (
          community.parentCommunityId === parentId &&
          !invalid.has(community.id)
        ) {
          invalid.add(community.id);
          next.push(community.id);
        }
      }
    }
    frontier = next;
  }

  return invalid;
}

export function getParentCommunityOptions(
  communities: Community[],
  editingCommunityId?: string,
): Community[] {
  const invalidIds = getInvalidParentCommunityIds(
    editingCommunityId,
    communities,
  );
  return communities.filter((community) => !invalidIds.has(community.id));
}
